import * as moment from 'moment';

import { IResourceProvider } from 'common/resourceprovider';

export function dateTimeTransmissionFormat(): string {
    return 'YYYY-MM-DDTHH:mm:ss';
}

export function defaultShortDateTimeFormat(): string {
    return 'YYYY-MM-DD HH:mm:ss';
}

export function shortDateTimeOffsetFormat(): string {
    return 'YYYY-MM-DD HH:mm:ss Z';
}

export function readDataContractSerializedJsonDate(s: string) {
    return (s === null || s === undefined) ? s : moment(new Date(parseInt(s.substr(6)))).format(dateTimeTransmissionFormat());
}

export function dateFormat(resources: IResourceProvider): string {
    return resources.getFormat('Date').replace(/d/g, 'D').replace(/yyyy/g, 'YYYY').replace(/yy/g, 'YY');
}

export function timeFormat(resources: IResourceProvider): string {
    return resources.getFormat('Time').replace(/tt/g, 'A');
}

export function longTimeFormat(resources: IResourceProvider): string {
    return resources.getFormat('LongTime').replace(/tt/g, 'A');
}

export function dateTimeFormat(resources: IResourceProvider): string {
    return dateFormat(resources) + ' ' + timeFormat(resources);
}

export function longDateTimeFormat(resources: IResourceProvider): string {
    return dateFormat(resources) + ' ' + longTimeFormat(resources);
}

export function toDefaultShortDateTimeFormat(t: string): string {
    return moment(t, dateTimeTransmissionFormat()).format(defaultShortDateTimeFormat());
}

// .NET ticks from 0001-01-01 00:00:00 to Unix epoch (1970-01-01 00:00:00)
const DOTNET_TICKS_TO_UNIX_EPOCH = 621355968000000000;
const TICKS_PER_MILLISECOND = 10000;

/**
 * Converts .NET ticks (100-nanosecond intervals since 0001-01-01) to formatted date string
 * @param t .NET ticks as string
 * @returns Formatted date string with timezone offset (e.g., "2025-12-15 14:30:00 -08:00")
 */
export function ticksToFormattedDate(t: string) {
    return moment((+t - DOTNET_TICKS_TO_UNIX_EPOCH) / TICKS_PER_MILLISECOND).format(defaultShortDateTimeFormat());
}

export const minDateTime = '0001-01-01 00:00:00';

export const maxDateTime = '9999-12-31 23:59:59';